import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { HTML_LANG } from './i18n'
import reportWebVitals from './reportWebVitals'
import { FollowProvider } from './State/Follow'
import { UiProvider } from './State/Ui'
import './Styles/index.scss'
import { getInstallId, startAds } from './Utils/ads'
import { readConsent, startAnalytics } from './Utils/analytics'

document.documentElement.lang = HTML_LANG
startAds() // before the first feed decides on its ads
// A choice made on an earlier visit; otherwise the banner asks (Overlays.js).
if (readConsent()) startAnalytics(readConsent(), getInstallId())

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <UiProvider>
      <FollowProvider>
        <App />
      </FollowProvider>
    </UiProvider>
  </React.StrictMode>
)

reportWebVitals()
